<template>
  <!--快捷登录-->
  <div class="login_Quick">

    <div class="">

      <!--header start-->
      <div class="header login-header">
        <a href="javascript:void(0);" @click="fn" class="icon-back"></a>
        手机快捷登录
        <!-- <div>
           <span class="close" @click="fn"></span>
         </div>-->
        <!--  <a href="javascript:void(0);" @click="fn" class="icon-out"></a>-->
      </div>
      <div class="line-gray"></div>
      <!--header end-->

      <!--content start-->
      <div class="login-content">
        <form class="lg-tabbox">
          <div class="group-item">
            <label style="width: 4em">+86</label>
            <div class="input-box input-tel" style="padding-left: 5em">
              <input type="tel" placeholder="请输入手机号" id="MobilePhone" class="MobilePhone" maxlength="11" v-model="mobilePhone"/>
              <div class="btn-del" style="display: none" v-show="mobilePhone != ''" @click="mobilePhone = ''">
              </div>
            </div>
          </div>
          <p class="text-danger" v-show="falseHints" id="MobilePhone-mess">{{falseHintsHtml}}</p>
          <p class="text-danger" v-show="telYzmMess" id="tel-yzm-mess">{{telYzmMessHtml}}</p>
          <p class="text-danger" v-show="yzmMess" id="img-yzm-mess"></p>
          <div class="group-item" style="position: relative">
            <label style="width: 4em">验证码</label>
            <div class="input-box input-yzm" style="padding-left: 5em">
              <input type="text" v-model="telYzm" placeholder="请输入验证码"  id="tel_yzm"/>
            </div>
            <a href="javascript:void(0);" class="btn-yzm puts"  style="right: -5px" @click="puts">发送验证码</a>
          </div>
          <div class="group-info">
            <a href="javascript:void(0);" class="font-lgr"  @click="login">登&nbsp;&nbsp;录</a>
          </div>
          <div class="group-mess">
            <router-link to="/register" tag="a">
              立即注册
            </router-link>
            <a href="javascript:void(0);" @click="table" style="float: right">
              账户登录
            </a>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data (){
      return {
        mobilePhone: '',  // 手机号
        telYzm: '',  // 验证码
        Time: 11,
        falseHints: false,
        falseHintsHtml: '',
        yzmMess: false,
        clicked: true,
        // thirdParty: true,
        num: 180,
        telYzmMess: false,
        telYzmMessHtml: ''
      }
    },
    methods: {
      fn(){
        $('#login_Alert').modal('hide');
        $('#myFlash').show();
      },
      table(){
        $('.quick-alert').hide();
        $('.signIn-alert').show();
      },
      signIn(){
        $('.quick-alert').hide();
        $('.signIn-alert').hide();
        //$('#login_Alert').modal('hide');
        //this.$router.push({name: 'login_SignIn'})
      },
      puts(){
        var that = this;
        if(that.num != 180){
          return false;
        }
        that.num = 180;
        if(!that.mobilePhone){
          that.falseHints = true;
          that.falseHintsHtml = '请输入手机号';
          return false;
        }
        // 验证手机号是否为空
        if (that.mobilePhone.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null) {
          that.falseHints = false;

        } else {
          that.falseHints = true;
          that.falseHintsHtml = '手机号格式不正确';
          return false;
        }
        var data = {
          method: 'getRequestVerifiCodeM',
          mobile: that.mobilePhone,
          verfiCodeType: '1',
          verificationCode: '4',
          isCheckCode: '1'
        };
        $.ajax({
          url: 'https://reg.cctv.com/mobile/regist/getVerifiCode.action',
          data: data,
          dataType: 'jsonp',
          success: function (mes) {
            console.log(mes)
            if(mes.errtype == 'success' || mes.errmsg == '成功'){
              var set = setInterval(function () {
                that.num =  that.num - 1;
                $('.btn-yzm').html(that.num + '秒');
                if (that.num <= 0) {
                  $('.btn-yzm').html('发送验证码');
                  clearInterval(set);
                  that.num = 180;
                }
              }, 1000)
            }else if(mes.errtype == 'sendagain') {
              that.falseHints = true;
              that.falseHintsHtml = '验证过于频繁,请稍后重试';
            }

            if (mes.errtype == 'mobilecodeerror') {
              that.falseHints = true;
              that.falseHintsHtml = '验证过于频繁,请稍后重试';
            }
            if (mes.errtype == 'ipsendagain') {
              that.falseHints = true;
              that.falseHintsHtml = '验证过于频繁,请稍后重试';
            }
            if (mes.errtype == 'mobileoften') {
              that.falseHints = true;
              that.falseHintsHtml = '验证过于频繁,请稍后重试';
            }
            if (mes.errtype == 'registered') {
              $('#phone-mess').show();
              $('#phone-mess').html(mes.errmsg);
            }
          }
        })
      },
      login(){
        var that = this;
        that.falseHints = false;
        that.yzmMess = false;
        that.telYzmMess = false;
        if(!that.mobilePhone){
          that.falseHints = true;
          that.falseHintsHtml = '请输入手机号';
          return false;
        }
        // 验证手机号是否为空
        if (that.mobilePhone.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null) {
          // $('#MobilePhone-mess').hide();
          that.falseHints = false;

        } else {
          that.falseHints = true;
          that.falseHintsHtml = '手机号格式不正确';
          return false;
        }
        if (!that.telYzm) {
          that.telYzmMess = true;
          that.telYzmMessHtml = '请输入手机验证码';
          return false;
        }
        var url = encodeURI('https://ishow.xiyou.cctv.com/');
        $.ajax({
          url: 'https://reg.cctv.com/mobile/mobileRegAndLogin.action',
          data: {
            mobile: that.mobilePhone,
            verifyCode: that.telYzm,
            from: url,
            service:  API.UrlName +  '/home/index',
            checkCode: '1'
          },
          dataType: 'jsonp',
          success: function (mes) {
            console.log(mes)
            if (mes.errType == '0' || mes.errMsg== '"成功"') {
              $('#login_Alert').modal('hide');
              $('#chatModal .info-mess').html('登录成功');
              $('#chatModal').modal('show');
              setTimeout(function(){
                $('#chatModal').modal('hide');
                var thisPathRoute = that.$route.path.split('/')[1];
                  if (thisPathRoute ==='detail') {
                    that.$http.get(API.IsJoin, {params: {activity_id: that.$route.params.id}})
                      .then(function (res) {
                        if (res.code == 0) {
                          if (res.data.isJoin == 0) {
                            that.$router.push({name: 'Notice', params: {id: that.$route.params.id}})
                          } else {
                            // that.$router.push({name: 'myActivity_MyParticipate', params: {id: that.$route.params.id}});
                            that.$router.push({name: 'Revise', params: {id: that.$route.params.id,form_id:0}});
                            return false;
                          }
                        }
                    })

                  } else {
                    window.location.reload()
                  }
              },1500)
            }
            if (mes.errType != '0') {
              alert(mes.errMsg);
            }
          }
        })
      }
    },
    mounted: function () {
      // 判断是否是小程序
      // var that = this;
      // function ready() {
      //   if(window.__wxjs_environment === 'miniprogram'){
      //     that.thirdParty = false;
      //   }
      // }
      // if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      //   document.addEventListener('WeixinJSBridgeReady', ready, false)
      // } else {
      //   ready()
      // }
    }

  }
</script>

<style>
  .close {
    color: #000;
    border-radius: 12px;
    line-height: 20px;
    text-align: center;
    font-size: 18px;
    padding: 1px;
    top: 1px;
    right: 2px;
    position: absolute;
  }
  .close::before {
    content: "\2716";
  }
</style>



// WEBPACK FOOTER //
// src/components/loginAlert/quick.vue